import type React from 'react';
import { useContext } from 'react';

import { FaTimes } from 'react-icons/fa';
import { ConfigContext } from '../context/ConfigContext';
import type { ChatWindowTitle } from '../types/ChatWindow';

type TProps = {
  onClose: (e: React.MouseEvent) => void;
};

export const ChatTitle: React.FC<TProps> = ({ onClose }) => {
  const getTextContainerType = (props: ChatWindowTitle) => {
    const { title, subtitle, headerTitleColor } = props;

    if (!subtitle) {
      return (
        <h3 className='header-title' style={{ color: headerTitleColor }}>
          {title}
        </h3>
      );
    }

    return (
      <div>
        <h3 className='header-title' style={{ color: headerTitleColor }}>
          {title}
        </h3>
        <h5 className='header-subtitle' style={{ color: headerTitleColor }}>
          {subtitle}
        </h5>
      </div>
    );
  };

  const getHeaderByType = (props: ChatWindowTitle) => {
    const {
      title,
      subtitle,
      avatarPath,
      avatarType,
      headerColor,
      headerTitleColor,
      headerType,
      showCloseButton,
    } = props;

    switch (headerType) {
      case 'slim': {
        const actualTitle = subtitle ? `${title} - ${subtitle}` : title;
        return (
          <div
            className='header-container slim'
            style={{ backgroundColor: headerColor }}>
            <div>
              <p
                className='header-title slim'
                style={{ color: headerTitleColor }}>
                {actualTitle}
              </p>
            </div>
            {showCloseButton && (
              <div className='header-close-button'>
                <FaTimes onClick={(e) => onClose(e)} />
              </div>
            )}
          </div>
        );
      }
      default: {
        return (
          <>
            <div
              className='header-container normal'
              style={{ backgroundColor: headerColor }}>
              {headerType === 'normal' && (
                <figure className={`header-avatar ${avatarType}`}>
                  <img src={avatarPath} alt='' />
                </figure>
              )}
              {getTextContainerType(props)}
              {showCloseButton && (
                <div className='header-close-button'>
                  <FaTimes onClick={(e) => onClose(e)} />
                </div>
              )}
            </div>
          </>
        );
      }
    }
  };

  const {
    headerConfig: {
      title,
      subtitle,
      logo: avatarPath,
      logoType: avatarType,
      headerType,
    },
    scheme: {
      header: { headerTitleColor, headerColor },
    },
    greeting: { showCloseButton },
  } = useContext(ConfigContext);

  return (
    <>
      {getHeaderByType({
        title,
        subtitle,
        avatarPath,
        avatarType,
        headerType,
        headerTitleColor,
        headerColor,
        showCloseButton,
      })}
    </>
  );
};

export default ChatTitle;
